import { render, staticRenderFns } from "./TicketDataModal.vue?vue&type=template&id=63551b59"
import script from "./TicketDataModal.vue?vue&type=script&lang=js"
export * from "./TicketDataModal.vue?vue&type=script&lang=js"
import style0 from "./TicketDataModal.vue?vue&type=style&index=0&id=63551b59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports